import React, { useState, useRef, useEffect } from "react";
import { Form, Col, Row, InputGroup, Button } from "react-bootstrap";
import "./Form.css";
import { useFormik } from "formik";
import { useQueryClient } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import { CMSSchema } from "./Schemas";
import { toast } from "react-toastify";
import { PatchAxios, PostAxios } from "../../../helper/AxiosHelper";

import Editor from "../GeneralUI/Editor/Editor";
const CMSForm = ({ edit }) => {
  const baseURL = process.env.REACT_APP_FILE_URL;
  const location = useLocation();
  const client = useQueryClient();
  const navigate = useNavigate();
  const imageRef = useRef(null);
  const [images, setImages] = useState("");

  function handleImageClick(e) {
    imageRef.current.click();
  }
  function handleImageChange(e) {
    const file = e.target.files[0];
    setImages(file);
  }
  const handlePost = async (e) => {
    const formData = new FormData();

    for (const key in values) {
      if (key === "image") {
        continue;
      } else if (key === "desc") {
        formData.append("desc", editorValue);
      } else formData.append(key, values[key]);
    }
    if (!edit) {
      if (InitialState.image instanceof File) {
        formData.append("image", InitialState.image);
      } else {
        formData.append("image", InitialState.image);
      }
    } else {
      if (edit && images instanceof File) {
        formData.append("image", images);
      } else {
        formData.append("image", InitialState.image);
      }
    }
    const res = edit
      ? await PatchAxios(`/admin/cms/${location.state._id}`, formData)
      : await PostAxios("/admin/cms/", formData);

    if (res.success) {
      client.refetchQueries("CmsList");
      navigate("/admin/cms");
      toast.success(edit ? "Updated Successfully" : "Added Successfully");
    } else {
      toast.error(res.message);
    }
  };
  const InitialState = {
    title: edit ? location.state.title : "",
    page_id: edit ? location.state.page_id : "",
    desc: edit ? location.state.desc : "",
    meta_title: edit ? location.state.meta_title : "",
    meta_desc: edit ? location.state.meta_desc : "",
    image: edit ? location.state.image : images,
    status: edit ? location.state.status : "inactive",
    slug: edit ? location.state.slug : "",
    seo_image: edit ? location.state.seo_image : images,
  };
  const [editorValue, setEditorValue] = useState(edit ? InitialState.desc : "");

  function handleImageClick(e) {
    imageRef.current.click();
  }
  function handleImageChange(e) {
    const file = e.target.files[0];
    setImages(file);
  }
  const {
    isSubmitting,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    isValid,
  } = useFormik({
    initialValues: InitialState,
    validationSchema: CMSSchema,
    onSubmit: async (values, action) => {
      const res = await handlePost();
      if (res) {
        action.resetForm();
      }
    },
  });
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <h2 className="text-center text-muted mb-2">
          {" "}
          {edit ? "Update" : "Add"} CMS
        </h2>
        <div className="image_holder_rect">
          {!images ? (
            <img
              src={
                edit && InitialState.seo_image
                  ? `${baseURL}/${InitialState.seo_image}`
                  : "https://media.istockphoto.com/id/1248723171/nl/vector/camera-pictogram-van-het-foto-uploaden-op-ge%C3%AFsoleerde-witte-achtergrond-eps-10-vector.jpg?s=612x612&w=0&k=20&c=WLTMjPeoFbET0aBnnJmLyzDE1wUkJu9nj07KPtmf8qg="
              }
              // className="rounded-circle"
              alt="Cinque Terre"
              height={200}
              width={300}
              onClick={handleImageClick}
            />
          ) : (
            <img
              src={URL.createObjectURL(images)}
              alt="bannerInput"
              // className="rounded-circle"
              height={200}
              width={300}
              onClick={handleImageClick}
            />
          )}
          <input
            type="file"
            ref={imageRef}
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>
        <Row className="m-2 p-2">
          <Col md={6}>
            <Form.Group>
              <Form.Label htmlFor="title">
                Title
                <span className="text-danger">*</span>
              </Form.Label>
              <InputGroup hasValidation>
                <Form.Control
                  required
                  type="text"
                  //id="title"
                  placeholder="Title"
                  name="title"
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </InputGroup>
              {errors.title && touched.title ? (
                <p className="text-danger">{errors.title}</p>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="slug">Slug</Form.Label>
              <Form.Control
                type="text"
                //id="slug"
                name="slug"
                value={values.slug}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.slug && touched.slug ? (
                <p className="text-danger">{errors.slug}</p>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="meta_title">Meta Title</Form.Label>
              <Form.Control
                type="text"
                //id="meta_title"
                name="meta_title"
                value={values.meta_title}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.meta_title && touched.meta_title ? (
                <p className="text-danger">{errors.meta_title}</p>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="meta_desc">Meta Desc</Form.Label>
              <Form.Control
                type="text"
                //id="meta_desc"
                name="meta_desc"
                value={values.meta_desc}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.meta_desc && touched.meta_desc ? (
                <p className="text-danger">{errors.meta_desc}</p>
              ) : null}
            </Form.Group>
          </Col>
          {!edit && (
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="page_id">Page Id</Form.Label>
                <Form.Control
                  type="text"
                  //id="page_id"
                  name="page_id"
                  value={values.page_id}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.page_id && touched.page_id ? (
                  <p className="text-danger">{errors.page_id}</p>
                ) : null}
              </Form.Group>
            </Col>
          )}
          <Col md={6}>
            <Form.Group>
              <Form.Label htmlFor="status">Status</Form.Label>
              <Form.Select
                className="form-select form-select-sm mb-3"
                aria-label="Default select example"
                //id="status"
                name="status"
                value={values.status}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </Form.Select>
              {errors.status && touched.status ? (
                <p className="text-danger">{errors.status}</p>
              ) : null}
            </Form.Group>
          </Col>
          <Editor values={editorValue} onValueChange={setEditorValue} />
        </Row>
        <div className="mt-4 d-flex justify-content-between">
          <Button
            type="submit"
            className={`btn btn-primary  `}
            onClick={handleSubmit}
            disabled={!isValid || isSubmitting}
          >
            {edit
              ? isSubmitting
                ? "Updating...."
                : "Update"
              : isSubmitting
              ? "Submitting...."
              : "Submit"}
          </Button>
          <Button
            className="btn btn-danger "
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </>
  );
};

export default CMSForm;
